/* eslint-disable react/jsx-no-bind */
//@flow

import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Select } from 'common/components/core/select';
import personnelMasterIds from 'common/tests/masterManagement/personnelMaster.json';

import {
    type PersonnelTypeEnumType,
    PersonnelTypeEnum
} from 'common/enums/PersonnelEnums';

type Props = {
    value: PersonnelTypeEnumType,
    onChange: (value: PersonnelTypeEnumType) => void,
    placeholder: string
};

const PersonnelTypeInput = (props: Props): React.Node => {
    const { value, placeholder, onChange } = props;
    const { t } = useTranslation('entityManagement');
    const handleChange = updatedOption => {
        onChange(updatedOption.value);
    };

    const options = React.useMemo(() => {
        return PersonnelTypeEnum.getOptions({
            translationKey: 'masterPersonnelProperties.personnelTypes'
        });
    }, []);

    return (
        <Select
            maxMenuHeight={190}
            noMarginBottom
            options={options}
            openMenuOnFocus
            blurInputOnSelect={false}
            isSearchable={false}
            placeholder={t(placeholder)}
            value={value}
            clearable={false}
            onChange={handleChange}
            testId={personnelMasterIds.addNewPersonnel.inputType}
        />
    );
};

export default PersonnelTypeInput;
